var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 21.475H9.4C5.4402 21.475 3.46031 21.475 2.23015 20.2448C1 19.0147 1 17.0347 1 13.075V10.975C1 7.01515 1 5.03526 2.23015 3.8051C3.46031 2.57495 5.4402 2.57495 9.4 2.57495H13.6C17.5598 2.57495 19.5397 2.57495 20.7698 3.8051C22 5.03526 22 7.01515 22 10.975V13.075C22 17.0347 22 19.0147 20.7698 20.2448C20.084 20.9306 19.1651 21.2341 17.8 21.3684",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.575V1",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 2.575V1",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.475 7.82501H16.3563H10.1875M1 7.82501H5.06875",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8002 16.225C17.8002 16.805 17.3301 17.275 16.7502 17.275C16.1703 17.275 15.7002 16.805 15.7002 16.225C15.7002 15.6451 16.1703 15.175 16.7502 15.175C17.3301 15.175 17.8002 15.6451 17.8002 16.225Z",
    fill: "#1C274C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8002 12.025C17.8002 12.6049 17.3301 13.075 16.7502 13.075C16.1703 13.075 15.7002 12.6049 15.7002 12.025C15.7002 11.4451 16.1703 10.975 16.7502 10.975C17.3301 10.975 17.8002 11.4451 17.8002 12.025Z",
    fill: "#1C274C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5502 16.225C12.5502 16.805 12.0801 17.275 11.5002 17.275C10.9203 17.275 10.4502 16.805 10.4502 16.225C10.4502 15.6451 10.9203 15.175 11.5002 15.175C12.0801 15.175 12.5502 15.6451 12.5502 16.225Z",
    fill: "#1C274C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5502 12.025C12.5502 12.6049 12.0801 13.075 11.5002 13.075C10.9203 13.075 10.4502 12.6049 10.4502 12.025C10.4502 11.4451 10.9203 10.975 11.5002 10.975C12.0801 10.975 12.5502 11.4451 12.5502 12.025Z",
    fill: "#1C274C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29995 16.225C7.29995 16.805 6.82985 17.275 6.24995 17.275C5.67006 17.275 5.19995 16.805 5.19995 16.225C5.19995 15.6451 5.67006 15.175 6.24995 15.175C6.82985 15.175 7.29995 15.6451 7.29995 16.225Z",
    fill: "#1C274C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29995 12.025C7.29995 12.6049 6.82985 13.075 6.24995 13.075C5.67006 13.075 5.19995 12.6049 5.19995 12.025C5.19995 11.4451 5.67006 10.975 6.24995 10.975C6.82985 10.975 7.29995 11.4451 7.29995 12.025Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.027272ec2ac40d18bf4a6cc61aa2bfd6.svg";
export { ForwardRef as ReactComponent };